import { Button } from '@/shared/components';
import type { ExchangeQuickSelectItem } from '../model';

type Props = {
  asset: ExchangeQuickSelectItem;
  onClick: () => void;
};

const ExchangeQuickSelectButton = ({ asset, onClick }: Props) => {
  return (
    <Button
      variant="outline"
      type="button"
      onClick={onClick}
      className="flex items-center h-[2.4rem] gap-[0.4rem] ps-[0.6rem] pe-[0.8rem] py-0 rounded-[0.8rem] border border-stroke bg-background shadow-none text-foreground hover:bg-secondary-bg hover:text-foreground">
      {asset.icon && (
        <img src={asset.icon} alt={asset.code} className="size-[1.6rem]" />
      )}
      <span className="headline5">{asset.code}</span>
    </Button>
  );
};

export default ExchangeQuickSelectButton;
